<template>
  <div class="virtual-key" @click="onClick">
    <template v-if="text"> {{ text }}</template>
    <div
      class="text"
      v-html="
        computedSelectedkey && allKeys[computedSelectedkey]
          ? allKeys[computedSelectedkey].text
          : ''
      "
      v-else
    ></div>
    <a-modal
      v-model="visible"
      width="100vw"
      :footer="null"
      :maskClosable="true"
      :maskStyle="{ background: '#00000088' }"
      :bodyStyle="{ background: '#333333' }"
    >
      <div class="virtual-keyboard">
        <div class="main">
          <div class="title">
            Main
          </div>
          <div
            class="key"
            v-for="(mainKey, key) in mainKeys"
            :key="key"
            :class="{ selected: computedSelectedkey === key }"
            :style="mainKey.style"
            @click="onKeyClick(key)"
          >
            <div class="text" v-html="mainKey.text"></div>
          </div>
        </div>
        <div class="center-cluster">
          <div class="title">
            Center Cluster
          </div>
          <div
            class="key"
            v-for="(centerClusterKey, key) in centerClusterKeys"
            :key="key"
            :class="{ selected: computedSelectedkey === key }"
            :style="centerClusterKey.style"
            @click="onKeyClick(key)"
          >
            <div class="text" v-html="centerClusterKey.text"></div>
          </div>
        </div>
        <div class="numpad">
          <div class="title">
            Numpad
          </div>
          <div
            class="key"
            v-for="(numpadKey, key) in numpadKeys"
            :key="key"
            :class="{ selected: computedSelectedkey === key }"
            :style="numpadKey.style"
            @click="onKeyClick(key)"
          >
            <div class="text" v-html="numpadKey.text"></div>
          </div>
        </div>
        <div class="mouse" v-if="showMouse">
          <div class="title">
            Mouse
          </div>
          <div
            class="key"
            v-for="(mouseKey, key) in mouseKeys"
            :key="key"
            :class="{ selected: computedSelectedkey === key }"
            :style="mouseKey.style"
            @click="onKeyClick(key)"
          >
            <div class="text" v-html="mouseKey.text"></div>
          </div>
        </div>

        <a-radio-group v-if="downAndUp" v-model="state" class="radio-group">
          <a-radio class="radio" value="down"> ↓ </a-radio>
          <a-radio class="radio" value="up"> ↑ </a-radio>
        </a-radio-group>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  mainKeys,
  centerClusterKeys,
  numpadKeys,
  mouseKeys,
  allKeys,
} from "./VirtualKeyboard";

export default {
  name: "CMouseVirtualKeyboard",
  props: {
    selectedKey: String,
    text: String,
    showMouse: Boolean,
    downAndUp: Boolean,
  },
  data() {
    return {
      mainKeys,
      centerClusterKeys,
      numpadKeys,
      mouseKeys,
      allKeys,
      visible: false,
      state: "down",
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
    computedSelectedkey() {
      if (this.downAndUp) {
        return this.selectedKey.replace(/0x1[01]/g, "0x");
      } else {
        return this.selectedKey;
      }
    },
  },
  methods: {
    onClick() {
      this.visible = true;
      if (this.downAndUp) {
        this.state =
          this.selectedKey.includes("0x11") || this.selectedKey.includes("0x00")
            ? "down"
            : "up";
      }
    },
    onKeyClick(key) {
      if (this.downAndUp) {
        if (this.state == "down") {
          if (key.includes("0xf")) {
            this.$emit("change", key.replace("0x", "0x00"));
          } else {
            this.$emit("change", key.replace("0x", "0x11"));
          }
        } else if (this.state == "up") {
          if (key.includes("0xf")) {
            this.$emit("change", key + "00");
          } else {
            this.$emit("change", key.replace("0x", "0x10"));
          }
        }
      } else {
        this.$emit("change", key);
      }
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
$key-width: 52px;
$key-margin: 6px;

.virtual-key {
  @include flex-center;
  width: $key-width;
  height: $key-width;
  border: 1px solid $primary-color;
  cursor: pointer;

  .text {
    font-size: 24px;
    color: $primary-color;
    transform: scale(0.5);
    line-height: 1.1;
  }
}

.virtual-keyboard {
  width: 1320px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 20px 0;
  background: #333333;

  > * {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 (10px - $key-margin) 0 10px;

    .title {
      width: 100%;
      font-size: 12px;
      color: $primary-color;
      text-align: left;
      margin: 0px 0 10px 0;
      white-space: nowrap;
    }

    .key {
      @include flex-center;
      width: $key-width;
      height: $key-width;
      margin: 0 $key-margin $key-margin 0;
      border: 1px solid #ffffff;
      cursor: pointer;

      .text {
        font-size: 24px;
        color: #ffffff;
        transform: scale(0.5);
        line-height: 1.1;
      }

      &.selected {
        border-color: $active-color;
        background: $active-color;
      }

      &:hover {
        border-color: $primary-color;
        background: $primary-color;
      }
    }

    .desc {
      width: ($key-width + $key-margin) * 6.3;
      line-height: $key-width / 2;
      font-size: 16px;
      text-align: left;
    }
  }

  .main {
    width: ($key-width + $key-margin) * 15;
  }

  .center-cluster {
    width: ($key-width + $key-margin) * 3;
  }

  .numpad {
    width: ($key-width + $key-margin) * 4;
  }

  .mouse {
    width: 1320px;
  }

  .radio-group {
    @include flex-center;
    width: 100%;
    margin-top: 10px;

    .radio {
      @include flex-center;
      margin: 0 30px;
    }
  }
}
</style>
